import React from 'react';
import styled from 'styled-components';
import { Container } from '../StyledComponents/StyledComponents';
import Posts from '../../posts/Posts';

const NavigationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 4rem 0;
    padding: 2rem 0;
    border-top: 1px solid #E0E0E0;
    border-bottom: 1px solid #E0E0E0;
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        flex-direction: column;
        gap: 2rem;
    }
`;

const NavButton = styled.a`
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    text-decoration: none;
    color: ${props => props.theme.body.text};
    background: ${props => props.theme.body.background};
    transition: all 0.3s ease;
    max-width: 300px;
    
    &:hover {
        border-color: ${props => props.theme.body.headers};
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
    }
    
    .nav-label {
        font-size: 0.9rem;
        color: ${props => props.theme.body.text};
        opacity: 0.7;
        margin-bottom: 0.5rem;
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
    }
    
    .nav-title {
        font-size: 1.1rem;
        font-weight: 600;
        font-family: 'Playfair Display', serif;
        color: ${props => props.theme.body.headers};
        line-height: 1.3;
    }
    
    &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
        pointer-events: none;
    }
`;

const PostNavigation = ({ currentRoute }) => {
    // Encontrar el índice del post actual
    const currentIndex = Posts.findIndex(post => post.route === currentRoute);
    
    // Posts anterior y siguiente
    const prevPost = currentIndex > 0 ? Posts[currentIndex - 1] : null;
    const nextPost = currentIndex < Posts.length - 1 ? Posts[currentIndex + 1] : null;
    
    return (
        <Container>
            <NavigationContainer>
                <NavButton 
                    href={prevPost ? `/${prevPost.route}` : '#'} 
                    className={!prevPost ? 'disabled' : ''}
                >
                    <span className="nav-label">← Entrada anterior</span>
                    <span className="nav-title">
                        {prevPost ? prevPost.title : 'No hay entrada anterior'}
                    </span>
                </NavButton>
                
                <NavButton 
                    href={nextPost ? `/${nextPost.route}` : '#'} 
                    className={!nextPost ? 'disabled' : ''}
                >
                    <span className="nav-label">Entrada siguiente →</span>
                    <span className="nav-title">
                        {nextPost ? nextPost.title : 'No hay entrada siguiente'}
                    </span>
                </NavButton>
            </NavigationContainer>
        </Container>
    );
};

export default PostNavigation;